<app-number-input-filter [config]="config.fromFilter"
                 [controlName]="config.fromFilter.controlName"
                 [form]="form"
                 [class.sm]="sm"></app-number-input-filter>

<span class="filter-separator">—</span>

<app-number-input-filter [config]="config.toFilter"
                 [controlName]="config.toFilter.controlName"
                 [form]="form"
                 [class.sm]="sm"></app-number-input-filter>

